export default "__VITE_ASSET__9A8NZ5PH__"